// Project Approval — the screen's strings in the portal's four languages (2026-10-21).
const en = {
  requestFailed: "Request failed ({{status}})",
  updated: "{{id}} updated.",
  updatedSkus: "{{id}} updated · {{n}} SKU added.",
  mailSentTo: "email sent to {{to}}",
  mailSkipped: "no email ({{reason}})",
  mailFailed: "email FAILED ({{error}})",
  decApprovedN: "{{id}} approved ({{n}} SKU)",
  decRejectedN: "{{id}} rejected ({{n}} SKU)",
  decPartly: "{{id}} partly approved — {{a}} approved, {{r}} rejected",
  decApproved: "{{id}} approved",
  decRejected: "{{id}} rejected",
  skusSent: "{{id}}: {{n}} SKU sent to the approver",
  resubmitted: "{{id}} sent back for approval",
  resubmittedN: "{{id}} sent back for approval ({{n}} SKU)",
  groupDeleted: "{{id}} deleted — {{skus}} SKU removed, {{samples}} sample round(s) kept without a project",
  ticketsCancelled: "{{n}} ticket(s) cancelled",
  requestSentTo: "request sent to {{to}}",
  theApprover: "the approver",
  notSent: "not sent: {{list}}",
  notDecided: "not decided: {{list}}",
  selectAll: "Select all",
  selectRow: "Select {{id}}",
  skuDeleted: "SKU deleted",
  editTitle: "Edit {{id}}",
  secProjectSub: "Basic details, schedule, status, stages, and linked samples",
  fillSeason: "— fill Season —",
  newSkuN: "New SKU {{n}}",
  dropSkuHead: "Delete this SKU?",
  dropSkuBody: "It goes now, not when you save, and it cannot be undone. Any sample round linked to this SKU is detached from it — the rounds themselves stay in Sample Tracker.",
  dropSkuBtn: "Delete SKU",
  projectsSubmitted_one: "{{count}} project submitted",
  projectsSubmitted_other: "{{count}} projects submitted",
  projectsSubmittedSkus_one: "{{count}} project ({{skus}} SKU) submitted",
  projectsSubmittedSkus_other: "{{count}} projects ({{skus}} SKU) submitted",
  emailsSent_one: "{{count}} email sent",
  emailsSent_other: "{{count}} emails sent",
  bulkApproved_one: "{{count}} project approved",
  bulkApproved_other: "{{count}} projects approved",
  bulkRejected_one: "{{count}} project rejected",
  bulkRejected_other: "{{count}} projects rejected",
};
const ko = {
  requestFailed: "요청 실패 ({{status}})",
  updated: "{{id}} 업데이트됨.",
  updatedSkus: "{{id}} 업데이트됨 · SKU {{n}}개 추가.",
  mailSentTo: "{{to}}에게 메일 발송",
  mailSkipped: "메일 없음 ({{reason}})",
  mailFailed: "메일 발송 실패 ({{error}})",
  decApprovedN: "{{id}} 승인 (SKU {{n}}개)",
  decRejectedN: "{{id}} 반려 (SKU {{n}}개)",
  decPartly: "{{id}} 일부 승인 — {{a}}개 승인, {{r}}개 반려",
  decApproved: "{{id}} 승인",
  decRejected: "{{id}} 반려",
  skusSent: "{{id}}: SKU {{n}}개를 승인자에게 보냄",
  resubmitted: "{{id}} 승인 재요청됨",
  resubmittedN: "{{id}} 승인 재요청됨 (SKU {{n}}개)",
  groupDeleted: "{{id}} 삭제됨 — SKU {{skus}}개 삭제, 샘플 라운드 {{samples}}개는 프로젝트 없이 유지",
  ticketsCancelled: "티켓 {{n}}건 취소",
  requestSentTo: "{{to}}에게 요청 발송",
  theApprover: "승인자",
  notSent: "미발송: {{list}}",
  notDecided: "미결정: {{list}}",
  selectAll: "전체 선택",
  selectRow: "{{id}} 선택",
  skuDeleted: "SKU 삭제됨",
  editTitle: "{{id}} 편집",
  secProjectSub: "기본 정보, 일정, 상태, 단계, 연결된 샘플",
  fillSeason: "— 시즌을 입력하세요 —",
  newSkuN: "새 SKU {{n}}",
  dropSkuHead: "이 SKU를 삭제할까요?",
  dropSkuBody: "저장할 때가 아니라 지금 바로 삭제되며 되돌릴 수 없습니다. 이 SKU에 연결된 샘플 라운드는 연결이 해제되며, 라운드 자체는 Sample Tracker에 남습니다.",
  dropSkuBtn: "SKU 삭제",
  projectsSubmitted_one: "프로젝트 {{count}}개 제출",
  projectsSubmitted_other: "프로젝트 {{count}}개 제출",
  projectsSubmittedSkus_one: "프로젝트 {{count}}개 (SKU {{skus}}개) 제출",
  projectsSubmittedSkus_other: "프로젝트 {{count}}개 (SKU {{skus}}개) 제출",
  emailsSent_one: "메일 {{count}}건 발송",
  emailsSent_other: "메일 {{count}}건 발송",
  bulkApproved_one: "프로젝트 {{count}}개 승인",
  bulkApproved_other: "프로젝트 {{count}}개 승인",
  bulkRejected_one: "프로젝트 {{count}}개 반려",
  bulkRejected_other: "프로젝트 {{count}}개 반려",
};
const vi = {
  requestFailed: "Yêu cầu không thành công ({{status}})",
  updated: "Đã cập nhật {{id}}.",
  updatedSkus: "Đã cập nhật {{id}} · thêm {{n}} SKU.",
  mailSentTo: "đã gửi email đến {{to}}",
  mailSkipped: "không gửi email ({{reason}})",
  mailFailed: "gửi email THẤT BẠI ({{error}})",
  decApprovedN: "Đã duyệt {{id}} ({{n}} SKU)",
  decRejectedN: "Đã từ chối {{id}} ({{n}} SKU)",
  decPartly: "Đã duyệt một phần {{id}} — {{a}} được duyệt, {{r}} bị từ chối",
  decApproved: "Đã duyệt {{id}}",
  decRejected: "Đã từ chối {{id}}",
  skusSent: "{{id}}: đã gửi {{n}} SKU cho người duyệt",
  resubmitted: "Đã gửi lại {{id}} để duyệt",
  resubmittedN: "Đã gửi lại {{id}} để duyệt ({{n}} SKU)",
  groupDeleted: "Đã xóa {{id}} — xóa {{skus}} SKU, giữ lại {{samples}} vòng mẫu không gắn dự án",
  ticketsCancelled: "đã hủy {{n}} ticket",
  requestSentTo: "đã gửi yêu cầu đến {{to}}",
  theApprover: "người duyệt",
  notSent: "chưa gửi: {{list}}",
  notDecided: "chưa quyết định: {{list}}",
  selectAll: "Chọn tất cả",
  selectRow: "Chọn {{id}}",
  skuDeleted: "Đã xóa SKU",
  editTitle: "Sửa {{id}}",
  secProjectSub: "Thông tin cơ bản, lịch trình, trạng thái, các giai đoạn và mẫu liên kết",
  fillSeason: "— điền Mùa —",
  newSkuN: "SKU mới {{n}}",
  dropSkuHead: "Xóa SKU này?",
  dropSkuBody: "SKU bị xóa ngay lúc này, không phải khi bạn lưu, và không thể hoàn tác. Các vòng mẫu gắn với SKU này sẽ được tách ra — bản thân các vòng mẫu vẫn còn trong Sample Tracker.",
  dropSkuBtn: "Xóa SKU",
  projectsSubmitted_one: "Đã gửi {{count}} dự án",
  projectsSubmitted_other: "Đã gửi {{count}} dự án",
  projectsSubmittedSkus_one: "Đã gửi {{count}} dự án ({{skus}} SKU)",
  projectsSubmittedSkus_other: "Đã gửi {{count}} dự án ({{skus}} SKU)",
  emailsSent_one: "đã gửi {{count}} email",
  emailsSent_other: "đã gửi {{count}} email",
  bulkApproved_one: "Đã duyệt {{count}} dự án",
  bulkApproved_other: "Đã duyệt {{count}} dự án",
  bulkRejected_one: "Đã từ chối {{count}} dự án",
  bulkRejected_other: "Đã từ chối {{count}} dự án",
};
const zh = {
  requestFailed: "请求失败（{{status}}）",
  updated: "{{id}} 已更新。",
  updatedSkus: "{{id}} 已更新 · 新增 {{n}} 个 SKU。",
  mailSentTo: "邮件已发送至 {{to}}",
  mailSkipped: "未发送邮件（{{reason}}）",
  mailFailed: "邮件发送失败（{{error}}）",
  decApprovedN: "{{id}} 已批准（{{n}} 个 SKU）",
  decRejectedN: "{{id}} 已驳回（{{n}} 个 SKU）",
  decPartly: "{{id}} 部分批准 — {{a}} 个批准，{{r}} 个驳回",
  decApproved: "{{id}} 已批准",
  decRejected: "{{id}} 已驳回",
  skusSent: "{{id}}：已将 {{n}} 个 SKU 发送给审批人",
  resubmitted: "{{id}} 已重新提交审批",
  resubmittedN: "{{id}} 已重新提交审批（{{n}} 个 SKU）",
  groupDeleted: "{{id}} 已删除 — 删除 {{skus}} 个 SKU，保留 {{samples}} 个样品轮次（不再关联项目）",
  ticketsCancelled: "已取消 {{n}} 张工单",
  requestSentTo: "请求已发送至 {{to}}",
  theApprover: "审批人",
  notSent: "未发送：{{list}}",
  notDecided: "未决定：{{list}}",
  selectAll: "全选",
  selectRow: "选择 {{id}}",
  skuDeleted: "SKU 已删除",
  editTitle: "编辑 {{id}}",
  secProjectSub: "基本信息、进度、状态、阶段和关联样品",
  fillSeason: "— 请填写季 —",
  newSkuN: "新 SKU {{n}}",
  dropSkuHead: "删除此 SKU？",
  dropSkuBody: "将立即删除（而非保存时），且无法撤销。与此 SKU 关联的样品轮次会解除关联 — 轮次本身仍保留在样品跟踪中。",
  dropSkuBtn: "删除 SKU",
  projectsSubmitted_one: "已提交 {{count}} 个项目",
  projectsSubmitted_other: "已提交 {{count}} 个项目",
  projectsSubmittedSkus_one: "已提交 {{count}} 个项目（{{skus}} 个 SKU）",
  projectsSubmittedSkus_other: "已提交 {{count}} 个项目（{{skus}} 个 SKU）",
  emailsSent_one: "已发送 {{count}} 封邮件",
  emailsSent_other: "已发送 {{count}} 封邮件",
  bulkApproved_one: "已批准 {{count}} 个项目",
  bulkApproved_other: "已批准 {{count}} 个项目",
  bulkRejected_one: "已驳回 {{count}} 个项目",
  bulkRejected_other: "已驳回 {{count}} 个项目",
};

const dictionary = { ns: 'xPa', en, ko, vi, zh };

export default dictionary;
